//import firebase from "firebase/app";
//import "firebase/firestore";
import firebase from "../../config/fbConfig"; // ✅ chemin vers ton fichier d'initialisation

const db = firebase.firestore();

export const logCoachInteraction = async (userId, interaction) => {
  try {
    const docRef = await db
      .collection(`users/${userId}/coachInteractions`)
      .add({
        type: interaction.type,
        messageSent: interaction.messageSent,
        responseExpected: interaction.responseExpected || false,
        userResponse: interaction.userResponse || null,
        actionTaken: interaction.actionTaken || null,
        handledBy: interaction.handledBy || 'AI',
        timestamp: firebase.firestore.FieldValue.serverTimestamp(), // v8 timestamp
      });
    console.log("Interaction enregistrée avec ID :", docRef.id);
    return docRef;
  } catch (error) {
    console.error("Erreur lors de l'enregistrement de l'interaction :", error);
    return null;
  }
};
